export enum LocalStorageKeys {
  SESSION_TIMER_KEY = 'session-timer',
}
